import firebase from '@firebase/app';

export const registerPublication = (uidProfessor, exercise, callback) => {
  exercise.date_create = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("publications")
    .add(exercise)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const updatePublication = (uidProfessor, uid, publication, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("publications")
    .doc(uid)
    .update(publication)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const publicationsList = (uidProfessor, callback) => {

  return firebase.firestore()
    .collection("professors")
    .doc(uidProfessor)
    .collection("publications").orderBy("date_create", "desc")
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}



// WEBPACK FOOTER //
// src/dao-firebase/publication-firebase.js